import React, {useState} from 'react';
import {View} from 'react-native';
import isFinite from 'lodash/isFinite';
import PropTypes from 'prop-types';

import sy from '~/styles';
import {
  Text,
  Dialog,
  FormTextInput,
  FormNumberInput,
} from '~/components/controls';

const DiscountInvoiceDialog = ({onDismiss, onInvoice}) => {
  const [discountInvoiceNumber, setDiscountInvoiceNumber] = useState('');
  const [discountPercentage, setDiscountPercentage] = useState(0);

  return (
    <Dialog
      visible={true}
      title="Kortingsfactuur"
      onDismiss={onDismiss}
      buttons={[
        {
          text: 'Annuleren',
          onPress: onDismiss,
        },
        {
          text: 'Verzenden',
          textStyle: {color: '#972727'},
          onPress: () => onInvoice(discountInvoiceNumber, discountPercentage),
          disabled:
            !discountInvoiceNumber ||
            !isFinite(discountPercentage) ||
            discountPercentage <= 0 ||
            discountPercentage > 100,
        },
      ]}>
      <View style={[sy['py-4'], sy['gap-4']]}>
        <Text>
          Voor deze schadewerkopdracht is het opgegeven van een kortingsfactuur
          verplicht.
        </Text>
        <FormTextInput
          label="Nummer"
          value={discountInvoiceNumber}
          onChangeText={(value) => setDiscountInvoiceNumber(value)}
        />
        <FormNumberInput
          label="Korting (%)"
          value={discountPercentage}
          digits={2}
          onChangeNumber={(value) => {
            const percentage = Math.min(Math.max(value, 0), 100);
            setDiscountPercentage(percentage);
            return percentage;
          }}
        />
      </View>
    </Dialog>
  );
};
DiscountInvoiceDialog.propTypes = {
  onDismiss: PropTypes.any,
  onInvoice: PropTypes.any,
};

export default DiscountInvoiceDialog;
